import React from 'react';

import { Link } from 'gatsby';

import * as T from './MenuLinks.types';
import * as S from './MenuLinks.module.css';
import { IMenuLink } from '../Menu.types';

export const MenuLinks: React.FunctionComponent<T.IMenuLinksProps> = ({
  links,
  toggle,
}) => (
  <>
    {links.map((link: IMenuLink, index: number) => {
      const isExternal: boolean =
        link.isExternal !== undefined
          ? link.isExternal
          : /https?:\/\//.test(link.href);

      if (isExternal) {
        return (
          <a className={S.menuItem} href={link.href} key={index}>
            {link.title}
          </a>
        );
      }

      return (
        <Link
          className={S.menuItem}
          to={link.href}
          key={index}
          onClick={toggle}
        >
          {link.title}
        </Link>
      );
    })}
  </>
);
